import { createSelector } from "reselect"
import { get, findIndex } from "lodash"
import { getFilterableCategories } from "selectors/factors"
import { getSelectedModelId } from "modules/portfolio-root/selectors/portfolios"

const getCategory = state => get(state, "modules.factorCategorySelector.category")

export const getSelectedCategory = createSelector(
  [getCategory, getSelectedModelId, getFilterableCategories],
  (category, modelId, categories) => {
    if (category === "default") {
      if (findIndex(categories, { id: "style" }) > -1) return "style"
      return "all"
    } else {
      return category
    }
  },
)
